import React from 'react'
import { DateRangeFilter } from '../DateRangeFilter'

export const ExpirationDateFilter = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return <DateRangeFilter title="Expiration Date" isNested={isNested} />
  },
)
